import { jsx, Global } from '@emotion/core';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import { motion } from 'framer-motion';
import { backdropStyles, modalStyles, modalSizes, modalAnimationVariants, backdropAnimationVariants } from './styles';
export var GenericModalWrapper = function GenericModalWrapper(_a) {
  var isOpen = _a.isOpen,
      testId = _a["data-testid"],
      children = _a.children,
      _b = _a.size,
      size = _b === void 0 ? 'default' : _b,
      onClose = _a.onClose;
  return jsx(DialogOverlay, {
    isOpen: isOpen,
    onDismiss: onClose
  }, jsx(Global, {
    styles: {
      ':root': {
        '--reach-dialog': 1
      }
    }
  }), jsx(motion.div, {
    css: [backdropStyles, {
      pointerEvents: isOpen ? 'auto' : 'none',
      position: 'fixed'
    }],
    initial: "hidden",
    animate: isOpen ? 'visible' : 'hidden',
    variants: backdropAnimationVariants,
    "data-testid": testId ? testId + "-overlay" : undefined
  }, jsx(DialogContent, {
    "aria-labelledby": "modal-header"
  }, jsx(motion.div, {
    css: [modalStyles, {
      display: isOpen ? 'flex' : 'none',
      maxWidth: modalSizes[size] + "px",
      flexDirection: 'column',
      position: 'fixed'
    }],
    initial: "hidden",
    animate: isOpen ? 'visible' : 'hidden',
    variants: modalAnimationVariants,
    "data-testid": testId ? testId + "-modal" : undefined
  }, children))));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Modal/GenericModalWrapper.js
// module id = 380
// module chunks = 0